import {AfterViewInit, ChangeDetectorRef, Component} from "@angular/core";
import {EntityData, EntityDataStatus, EntityModelStatus, provideEntityModel} from "@fedeltapointofsale/data-client";
import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {PeriodScheduleEntityModel} from "../period-schedule-entity.model";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";
import {PeriodScheduleRuleData} from "../period-schedule.data";
import {Plugin} from "../../../config";
import {EditMode} from "../../../framework/entity/edit/edit-page/edit-mode";
import {first} from "rxjs";

@Component({
    selector: "wbo-period-schedule-edit-page",
    templateUrl: "./period-schedule-edit-page.component.html",
    styleUrls: ["./period-schedule-edit-page.component.scss"],
    providers: [provideEntityModel(PeriodScheduleEntityModel)]
})
export class PeriodScheduleEditPageComponent extends AbstractEditPage implements AfterViewInit {
    Plugin = Plugin;
    EditMode = EditMode;
    EntityDataStatus = EntityDataStatus;

    constructor(public model: PeriodScheduleEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService, false);
    }

    ngAfterViewInit(): void {
        this.model.$data.pipe(first()).subscribe(() => this.advancedChanged());
    }

    advancedChanged(): void {
        this.changeDetectorRef.detectChanges();
        this.responsiveService.emitWindowWidthChange();
    }

    get isScheduled(): boolean {
        return this.model.data.overallRule.hasCriteria || !!this.model.data.activeRules.length || !!this.model.data.inactiveRules.length;
    }

    get showPeriodsInfo() {
        return !(this.model.data.showAsVenueStatus && this.model.data.venueStatusSwitchable);
    }

    addRule(rules: PeriodScheduleRuleData[]): void {
        rules.push(EntityData.create(PeriodScheduleRuleData));
    }

    deleteRule(rules: PeriodScheduleRuleData[], rule: PeriodScheduleRuleData): void {
        const i: number = rules.indexOf(rule);
        if (i >= 0) {
            rules.splice(i, 1);
        }
    }
}
